const NAME_SPACE = 'ui-search-shopping-cart-intervention';

export { NAME_SPACE };
